import { palette } from '@/styles/figma-tokens';

interface IconProps {
  className?: string;
  /** Circle (ring) fill — defaults to mid gray. */
  color?: string;
  /** Diagonal strikethrough fill — defaults to light gray. */
  accentColor?: string;
}

export default function PencilIcon({
  className,
  color = palette.grey['600'],
  accentColor = palette.grey['500'],
}: IconProps) {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        opacity="0.4"
        d="M0.92052 20.5601L2.56486 15.4472C2.67213 15.1129 3.11143 14.9318 3.49453 15.0661C5.77507 15.8658 7.39526 17.2157 8.35512 19.1158C8.51625 19.4346 8.29893 19.8006 7.89771 19.8904L1.76103 21.2604C1.25115 21.3742 0.783995 20.9853 0.920984 20.5605L0.92052 20.5601Z"
        fill={color}
      />
      <path
        opacity="0.4"
        d="M16.7495 1.59862L14.2872 3.91944C14.0501 4.14293 14.0501 4.50527 14.2872 4.72875L18.6258 8.81807C18.8629 9.04155 19.2473 9.04155 19.4844 8.81807L21.9467 6.49725C22.1838 6.27376 22.1838 5.91142 21.9467 5.68793L17.6081 1.59862C17.371 1.37513 16.9866 1.37513 16.7495 1.59862Z"
        fill={accentColor}
      />
      <path
        d="M17.002 10.8661L9.77209 17.3722C9.6452 17.4878 9.4721 17.5378 9.30488 17.5223C9.11885 17.505 8.96259 17.3841 8.88897 17.2294C8.6395 16.7068 8.19539 15.9583 7.41605 15.2284C6.53488 14.4027 5.60124 13.9523 4.9852 13.7133C4.79487 13.6397 4.65506 13.4765 4.65271 13.2901C4.65271 13.288 4.65271 13.2858 4.65271 13.2837C4.65271 13.1509 4.70871 13.018 4.82072 12.9161L12.0506 6.4101C12.2773 6.20851 12.6439 6.20851 12.8679 6.4101L15.7844 9.03458L15.8517 9.0952L17.0024 10.1306C17.2291 10.3347 17.2291 10.6645 17.0024 10.8661H17.002Z"
        fill="currentColor"
      />
    </svg>
  );
}
